import React, { useContext } from "react";
import { EuiButton, htmlIdGenerator } from "@elastic/eui";
import { useAnketa } from "../context_provider";

export const ActionButton = ({ action }: any): JSX.Element => {
  const ctx = useAnketa();

  const onClick = (): void => {
    ctx.onAction(action);
  };

  return (
    <EuiButton
      key={htmlIdGenerator()()}
      style={{ margin: "2rem" }}
      disabled={!action.enabled}
      onClick={onClick}
      title={ctx.i18nContext.render(action.help)}
      fill
    >
      {ctx.i18nContext.render(action.title)}
    </EuiButton>
  );
};
